// ////////////////////////////////////////////////////////////
// Riot mixin containing tools for parsing a name into parts //
// ////////////////////////////////////////////////////////////

export default {

  // DEFAULT_USERS_ADDRESS_PREFIXES = "MR:MRS:MS:DR"
  parseFirstName(input) {
    const regex = /^(MRS|MR|MS|DR)\b\s(.*)/i
    const match = input.match(regex)
    let parsed
    if (match) {
      parsed = {
        prefix: match[1],
        firstName: match[2],
        fullFirstName: input,
      }
    } else {
      parsed = {
        prefix: null,
        firstName: input,
        fullFirstName: input,
      }
    }

    return parsed
  },

  // DEFAULT_USERS_ADDRESS_SUFFIXES = "CPA:DDS:II:III:IV:JR:MD:SR"
  parseLastName(input) {
    const regex = /(.*)\s(CPA|DDS|III|II|IV|JR|MD|SR)$/i
    const match = input.match(regex)
    let parsed

    if (match) {
      parsed = {
        suffix: match[2],
        lastName: match[1],
        fullLastName: input,
      }
    } else {
      parsed = {
        suffix: null,
        lastName: input,
        fullLastName: input,
      }
    }

    return parsed
  },
}
